<template>
  <div id="CampaignEditSegmentation" class="Main-Content">
    <router-view v-if="!loading" :campaign="campaign"></router-view>
  </div>
</template>

<script>

export default {
  name: 'CampaignEditSegmentation',
  data () {
    return {
      campaign: null,
      loading: true
    }
  },
  mounted() {
    this.getCampaign()
    this.$watch('$route.params.id', this.getCampaign)
  },
  methods: {
    getCampaign() {
      this.loading = true
      this.api.getCampaign(parseInt(this.$route.params.id))
      .then((data) => {
        this.campaign = data
        this.loading = false
      })
      .catch(this.apiCatch)
    }
  }
}

</script>

<style lang="scss">
// #CampaignEditSegmentation {
  
// }
</style>
